import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const zmseldConfig: TSPConfig = {
  key: 'zmseld',
  name: 'ZMSELD',
  category: TSPCategory.API_KEY,
  helpText:
    'Please request an API Key from ZMSELD support. Then input it here.',
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'Enter API key' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default zmseldConfig;
